import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/slide-decks',
        component: () => import('@/pages/slide-decks/SlideDeckIndex.vue'),
        props: true,
        children: [
            {
                name: 'slide-decks-index',
                path: '',
                component: () => import('@/components/slide-decks/SlideDecksView.vue'),
                meta: {
                    title: 'Slide Decks',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view all', subject: 'slide decks' },
                },
                props: true,
            },

            {
                name: 'slide-decks-index-archive',
                path: '/slide-decks/archive',
                component: () => import('@/components/slide-decks/SlideDecksView.vue'),
                meta: {
                    title: 'Archived Slide Decks',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('archive a slide deck'),
                },
                props: true,
            },
        ],
    },

    {
        path: '/slide-decks/create',
        name: 'slide-deck-create',
        component: () => import('@/pages/slide-decks/SlideDeckCreate.vue'),
        meta: {
            title: 'Create Slide Deck',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'create', subject: 'slide deck' },
        },
        props: true,
    },
    {
        path: '/slide-decks/:slideDeckReferenceId',
        name: 'slide-deck-view',
        component: () => import('@/pages/slide-decks/SlideDeckShow.vue'),
        meta: {
            title: 'Slide Deck',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view', subject: 'slide deck' },
        },
        props: true,
    },
    {
        path: '/slide-decks/:slideDeckReferenceId/edit',
        name: 'slide-deck-edit',
        component: () => import('@/pages/slide-decks/SlideDeckEdit.vue'),
        meta: {
            title: 'Edit Slide Deck',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'edit', subject: 'slide deck' },
        },
        props: true,
    },
];
